import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
interface FooterProps {
  onNavigate: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="bg-[#0a1d3d] text-white pt-20 pb-10" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16" data-id="element-111">
          {/* Column 1: Brand */}
          <div className="col-span-2 lg:col-span-1 space-y-6" data-id="element-112">
            <div className="bg-white rounded-xl px-4 py-2 shadow-md inline-block" data-id="element-113">
              <img src="https://cdn.magicpatterns.com/uploads/8EY7ZJX3JwCeaKXUAMAeGe/logo-rfwu7jdkpjy48aomhgtuqqnjwynn4g1lfd5t8lacs0.png" alt="WheelAround Rentals Logo" className="h-10 w-auto object-contain" data-id="element-114" />
            </div>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-115">
              Your trusted source for mobility equipment rental in the District
              of Columbia Metro area and beyond. We provide reliable solutions
              for tourists and locals alike.
            </p>
            <div className="flex space-x-4" data-id="element-116">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" aria-label="Facebook" data-id="element-117">
                <FacebookIcon className="w-5 h-5" data-id="element-118" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" aria-label="Twitter" data-id="element-119">
                <TwitterIcon className="w-5 h-5" data-id="element-120" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" aria-label="Instagram" data-id="element-121">
                <InstagramIcon className="w-5 h-5" data-id="element-122" />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-123">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-124">Quick Links</h4>
            <ul className="space-y-3" data-id="element-125">
              <li data-id="element-126">
                <button onClick={() => onNavigate('home')} className="text-white/70 hover:text-brand-red transition-colors text-sm cursor-pointer" data-id="element-127">
                  Home
                </button>
              </li>
              <li data-id="element-128">
                <button onClick={() => onNavigate('about')} className="text-white/70 hover:text-brand-red transition-colors text-sm cursor-pointer" data-id="element-129">
                  About Us
                </button>
              </li>
              <li data-id="element-130">
                <button onClick={() => onNavigate('services')} className="text-white/70 hover:text-brand-red transition-colors text-sm cursor-pointer" data-id="element-131">
                  Services
                </button>
              </li>
              <li data-id="element-132">
                <button onClick={() => onNavigate('hotel-rentals')} className="text-white/70 hover:text-brand-red transition-colors text-sm cursor-pointer" data-id="element-133">
                  Hotel Rentals
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3: Support */}
          <div data-id="element-134">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-135">Support</h4>
            <ul className="space-y-3" data-id="element-136">
              <li data-id="element-137">
                <button onClick={() => onNavigate('faq')} className="text-white/70 hover:text-brand-red transition-colors text-sm cursor-pointer" data-id="element-138">
                  FAQs
                </button>
              </li>
              <li data-id="element-139">
                <button onClick={() => onNavigate('cancellation-policy')} className="text-white/70 hover:text-brand-red transition-colors text-sm cursor-pointer" data-id="element-140">
                  Policies
                </button>
              </li>
              <li data-id="element-141">
                <button onClick={() => onNavigate('contact')} className="text-white/70 hover:text-brand-red transition-colors text-sm cursor-pointer" data-id="element-142">
                  Contact Us
                </button>
              </li>
              <li data-id="element-143">
                <button onClick={() => onNavigate('blogs')} className="text-white/70 hover:text-brand-red transition-colors text-sm cursor-pointer" data-id="element-144">
                  Blogs
                </button>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div data-id="element-145">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-146">Contact Info</h4>
            <ul className="space-y-4" data-id="element-147">
              <li className="flex items-start gap-3" data-id="element-148">
                <MapPinIcon className="w-5 h-5 text-brand-red flex-shrink-0 mt-0.5" data-id="element-149" />
                <span className="text-white/70 text-sm" data-id="element-150">
                  11705 Berry Rd Suite 301-9
                  <br data-id="element-151" />
                  Waldorf MD 20602
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-152">
                <PhoneIcon className="w-5 h-5 text-brand-red flex-shrink-0" data-id="element-153" />
                <div className="flex flex-col" data-id="element-154">
                  <a href="tel:+18003954459" className="text-white/70 hover:text-white text-sm transition-colors" data-id="element-155">
                    +1 (800) 395-4459
                  </a>
                  <a href="tel:+12023679965" className="text-white/70 hover:text-white text-sm transition-colors" data-id="element-156">
                    +1 (202) 367-9965
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3" data-id="element-157">
                <MailIcon className="w-5 h-5 text-brand-red flex-shrink-0" data-id="element-158" />
                <a href="mailto:info@wheelaroundrentals.com" className="text-white/70 hover:text-white text-sm transition-colors" data-id="element-159">
                  info@wheelaroundrentals.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 text-center flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-160">
          <p className="text-white/50 text-sm" data-id="element-161">
            © 2024 WheelAround Rentals, Inc. All Rights Reserved.
          </p>
          <div className="flex gap-4 text-sm text-white/50" data-id="element-162">
            <button onClick={() => onNavigate('cancellation-policy')} className="hover:text-white transition-colors cursor-pointer" data-id="element-163">
              Cancellation Policy
            </button>
          </div>
        </div>
      </div>
    </footer>;
}